import { render, staticRenderFns } from "./Quatation.vue?vue&type=template&id=36868a58&"
import script from "./Quatation.vue?vue&type=script&lang=js&"
export * from "./Quatation.vue?vue&type=script&lang=js&"
import style0 from "./Quatation.vue?vue&type=style&index=0&id=36868a58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports